module Meevo.Plugins.Controls {

    declare let d3: any;

    const DEFAULT_OPTIONS: IDiscreteBarChartOptions = {
        type: 'discreteBarChart',
        height: 450,
        margin: {
            top: 20,
            right: 20,
            bottom: 65,
            left: 55
        },
        x: (d) => d.label,
        y: (d) => d.value,
        showValues: true,
        valueFormat: (d) => d3.format(',.2f')(d),
        transitionDuration: 500,
    }

    interface IDiscreteBarChartValueItem {
        label: string;
        value: number;
        color: string;
    }

    export interface IDiscreteBarChartDataRow {
        values: IDiscreteBarChartValueItem[];
    }

    type chartFormatter = (d) => string | number;


    export interface IDiscreteBarChartOptions {
        type?: string;
        height?: number;
        margin?: {
            top?: number;
            right?: number;
            bottom?: number;
            left?: number;
        };
        x?: chartFormatter;
        y?: chartFormatter;
        showValues?: true;
        valueFormat?: chartFormatter;
        transitionDuration?: number;
        rotateLabels?: number;
    }


    class MeevoDiscreteBarChartComponent<T> extends BaseChart<T, IDiscreteBarChartDataRow> {

        static $inject = ['$scope', '$element', '$timeout'];

        public chartOptions: IDiscreteBarChartOptions;
        public options: ID3ChartOptions<IDiscreteBarChartOptions>;
        public dataset = [];

        constructor($scope, $element, $timeout) {
            super($scope, $element, $timeout);

            this.options = {
                chart: {...DEFAULT_OPTIONS}
            };
        }

        $onInit() {
            super.$onInit();
            this.$scope.$watch(() => this.chartOptions, (value) => {
                this.options = {
                    chart: {...DEFAULT_OPTIONS, ...this.chartOptions}
                };
            });
        }

        public prepareData() {
            if (typeof this.mapFn === 'function') {
                this.data = <IDiscreteBarChartDataRow[]>[
                    {
                        values: this.inputData.map(this.mapFn) as any
                    }
                ];
            } else {
                this.data = <IDiscreteBarChartDataRow[]>[
                    {
                        values: <any>this.inputData
                    }
                ];
            }
        }
    }


    angular.module('meevo.components.controls')
        .component('meevoDiscreteBarChartComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/charts/discrete-bar-chart/discrete-bar-chart.html',
            controller: MeevoDiscreteBarChartComponent,
            controllerAs: '$ctrl',
            bindings: {
                title: '@',
                inputData: '<',
                mapFn: '=',
                chartOptions: '=',
            }
        });
}
